import { useAtomValue } from 'jotai';

import { uuidv4 } from '@looko-corp/acloset-react-kit/src/utils-ext/uuid';

import { atomPersist } from '@/utils/atom-persist';

export const persistAppStore = atomPersist('app-store', {
  deviceID: uuidv4(),
});

export const usePersistAppStore = () => {
  return useAtomValue(persistAppStore);
};
